import { render, staticRenderFns } from "./homeWindowPromotion.vue?vue&type=template&id=32a3b174&scoped=true&"
import script from "./homeWindowPromotion.vue?vue&type=script&lang=js&"
export * from "./homeWindowPromotion.vue?vue&type=script&lang=js&"
import style0 from "./homeWindowPromotion.vue?vue&type=style&index=0&id=32a3b174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3b174",
  null
  
)

export default component.exports